import React, { useState } from 'react';
import { Button, ButtonGroup, Checkbox, Text } from '@chakra-ui/react';

import { Modal, Textarea } from 'shared-components';
import { IMessage } from 'types';

import { UNI_ROLES, ENROLY_AGENT_ROLES, AGENT_ROLES } from '../../../../store/auth/types';

export interface IDispatchProps {
  onSubmitMessage: (message: IMessage) => void;
}

export interface IProps {
  userName: string;
  displayName: string;
  onClose?: () => void;
  role: string;
}

type ICustomProps = IProps & IDispatchProps;

const VisaPrepActivate = (props: ICustomProps) => {
  const initialMessage: IMessage = {
    message: '',
    isSendToStudent: true,
    messageType: 'agentStudent',
    createdAt: 0,
    author: '',
    authorName: '',
    messageFrom: 'agent',
    messageTo: 'student',
  };
  const [message, setMessage] = useState(initialMessage);
  const [isSendToStudent, setIsSendToStudent] = useState(true);

  const submitMessage = () => {
    if (!message) {
      return;
    }
    const author = props.userName || 'Anonymous';
    const newMessage: IMessage = {
      message: `Visa Preparation: ${message.message}`,
      createdAt: Date.now(),
      isSendToStudent,
      messageType: 'agentStudent',
      author,
      authorName: props.displayName || author,
      messageFrom: 'agent',
      messageTo: isSendToStudent ? 'student' : 'agent',
      ...(UNI_ROLES.includes(props.role) ? { uniRead: true } : {}),
      ...(ENROLY_AGENT_ROLES.includes(props.role) ? { adminRead: true } : {}),
      ...(AGENT_ROLES.includes(props.role) ? { agentRead: true } : {}),
    };

    props.onSubmitMessage(newMessage);

    props.onClose!();
  };

  return (
    <Modal
      id={'visa-prep-activate'}
      show={true}
      title={`Unlock visa preparation`}
      onClose={props.onClose}
      footer={
        <ButtonGroup size={'lg'} spacing={3}>
          <Button onClick={props.onClose}>Cancel</Button>

          <Button id="submit-log-button" onClick={submitMessage} isDisabled={!message.message} variant="solid">
            Confirm
          </Button>
        </ButtonGroup>
      }
    >
      <Text mb={6}>Note: This action cannot be undone.</Text>

      <Textarea
        id={'message'}
        label={'Add note (required)'}
        value={message.message}
        onChange={(event: React.FormEvent<HTMLTextAreaElement>) =>
          setMessage({
            ...message,
            message: event.currentTarget.value,
          })
        }
        placeholder={'e.g. Spoke to student, they are ready to proceed to visa stage...'}
      />

      <Checkbox isChecked={isSendToStudent} onChange={() => setIsSendToStudent(!isSendToStudent)} size={'lg'}>
        Send this note to student
      </Checkbox>
    </Modal>
  );
};

export default VisaPrepActivate;
